import {GridColumns, GridColDef, GridRowsProp, GridValueFormatterParams} from '@mui/x-data-grid-pro';

export const homeBrokerColumns: GridColDef[] = [
    { field: 'company_id',
      type: 'string',
      headerName: 'Company ID',
      width: 120,
      valueGetter: (params) => params.row.company_sid || '',
    },
  { field: 'listadmin_id',
    type: 'number',
    headerName: 'ID',
    width: 50,
  },
  { field: 'listadmin_sid',
    type: 'string',
    headerName: 'SID',
    width: 125,
  },
  { field: 'company_name',
    type: 'string',
    headerName: 'Company Name',
    width: 200,
  },
  { field: 'city',
    type: 'string',
    headerName: 'City',
    width: 150,
  },
  { field: 'state',
    type: 'string',
    headerName: 'State',
    width: 100,
  },
  { field: 'postal_code',
    type: 'string',
    headerName: 'Postal Code',
    width: 125,
  },
  { field: 'federal_tax_id',
    type: 'string',
    headerName: 'Tax ID',
    width: 100,
  },
  { field: 'naics_code',
    type: 'string',
    headerName: 'NAICS',
    width: 100,
  },
  { field: 'phone',
    type: 'string',
    headerName: 'Phone',
    width: 100,
  },
  { field: 'representative_name',
    type: 'string',
    headerName: 'Contact Name',
    width: 150,
  },
  { field: 'representative_title',
    type: 'string',
    headerName: 'Contact Title',
    width: 150,
  },
  { field: 'representative_email',
    type: 'string',
    headerName: 'Contact Email',
    width: 150,
  },
  { field: 'modify_datetime',
    type: 'dateTime',
    headerName: 'Last Modified',
    width: 175,
  },
];

export const homeCustomerColumns: GridColDef[] = [
  { field: 'customer_id',
    type: 'number',
    headerName: 'ID',
    width: 80,
  },
  { field: 'company_sid',
    type: 'string',
    headerName: 'Org ID',
    width: 125,
  },
  { field: 'company_name',
    type: 'string',
    headerName: 'Company Name',
    width: 200,
  },
  { field: 'parent_company_name',
    type: 'string',
    headerName: 'Parent Company Name',
    width: 200,
  },
  { field: 'dba_name',
    type: 'string',
    headerName: 'DBA Name',
    width: 200,
  },
  { field: 'city',
    type: 'string',
    headerName: 'City',
    width: 150,
  },
  { field: 'state',
    type: 'string',
    headerName: 'State',
    width: 100,
  },
  { field: 'postal_code',
    type: 'string',
    headerName: 'Postal Code',
    width: 125,
  },
  { field: 'federal_tax_id',
    type: 'string',
    headerName: 'Tax ID',
    width: 100,
  },
  { field: 'naics_code',
    type: 'string',
    headerName: 'NAICS',
    width: 100,
  },
  { field: 'phone',
    type: 'string',
    headerName: 'Phone',
    width: 100,
  },
  { field: 'representative_name',
    type: 'string',
    headerName: 'Contact Name',
    width: 150,
  },
  { field: 'representative_title',
    type: 'string',
    headerName: 'Contact Title',
    width: 150,
  },
  { field: 'representative_email',
    type: 'string',
    headerName: 'Contact Email',
    width: 150,
  },
  { field: 'customer_since_date',
    type: 'dateTime',
    headerName: 'Customer Since',
    width: 175,
  },
  { field: 'modify_datetime',
    type: 'dateTime',
    headerName: 'Last Modified',
    width: 175,
  },
];

export const homeListAdminData: GridRowsProp = [
    {
      id: 1,
      broker_org_id: "S1014",
      broker_type: 1,
      company_name: "THE FIDELIS GROUP, INC.",
      address1: "167 HOLLAND AVE.",
      address2: "",
      city: "NEW MILFORD",
      state: "NJ",
      postal_code: "07646",
      federal_tax_id: "223-791-112/",
      naics_code: "",
      phone: "(201) 599-2444",
      representative_name: "LIVLEEN SINGH",
      representative_title: "PARTNER",
      representative_email: "",
      notes: "",
      create_datetime: "2021-12-23T17:08:09.690853Z",
      modify_datetime: "2021-12-23T17:08:09.690853Z"
    },
    {
      id: 2,
      broker_org_id: "S1018",
      broker_type: 1,
      company_name: "AIMIA",
      address1: "14305 XENIUM LANE",
      address2: "",
      city: "PLYMOUTH",
      state: "MN",
      postal_code: "554441",
      federal_tax_id: "0",
      naics_code: "541860",
      phone: "(763) 212-4579",
      representative_name: "RYAN DAGNER",
      representative_title: "ACCOUNT MANAGER",
      representative_email: "N/A",
      notes: "",
      create_datetime: "2021-12-23T17:08:09.690853Z",
      modify_datetime: "2021-12-23T17:08:09.690853Z"
    },
    {
      id: 3,
      broker_org_id: "S1022",
      broker_type: 1,
      company_name: "ACXIOM CORP",
      address1: "301 INDUSTRIAL BLVD.",
      address2: "",
      city: "CONWAY",
      state: "AR",
      postal_code: "72032",
      federal_tax_id: "71-6581897",
      naics_code: "",
      phone: "(501) 342-4037",
      representative_name: "TARA LLEWELLYN",
      representative_title: "SOLUTION DELIVERY LEADER",
      representative_email: "",
      notes: "",
      create_datetime: "2021-12-23T17:08:09.690853Z",
      modify_datetime: "2021-12-23T17:08:09.690853Z"
    },
    {
      id: 4,
      broker_org_id: "S1027",
      broker_type: 1,
      company_name: "AMERICAN MAILERS",
      address1: "100 AMERICAN WAY",
      address2: "",
      city: "DETROIT",
      state: "MI",
      postal_code: "48209",
      federal_tax_id: "38-2963425",
      naics_code: "733100",
      phone: "313-842-4000",
      representative_name: "WILLIAM CADAVID",
      representative_title: "IT MANAGER",
      representative_email: "WCADAVID@AMERICANMAILERS.COM",
      notes: "",
      create_datetime: "2021-12-23T17:08:09.690853Z",
      modify_datetime: "2021-12-23T17:08:09.690853Z"
    },
    {
      id: 5,
      broker_org_id: "S1029",
      broker_type: 1,
      company_name: "MKTG SERVICES",
      address1: "187 BALLARDVALE ST STE B110",
      address2: "",
      city: "WILMINGTON",
      state: "MA",
      postal_code: "01887",
      federal_tax_id: "043389064",
      naics_code: "000000",
      phone: "800-677-7959 x 3012",
      representative_name: "TAMMY DANDURANT",
      representative_title: "ACCOUNT MANAGER",
      representative_email: "",
      notes: "",
      create_datetime: "2021-12-23T17:08:09.690853Z",
      modify_datetime: "2021-12-23T17:08:09.690853Z"
    },
    {
      id: 6,
      broker_org_id: "S1037",
      broker_type: 2,
      company_name: "MCRB",
      address1: "20660 NORDHOFF ST",
      address2: "",
      city: "CHATSWORTH",
      state: "CA",
      postal_code: "91311",
      federal_tax_id: "95-3218784",
      naics_code: "514210",
      phone: "(818) 407-4300",
      representative_name: "MAX H. SCHULZE",
      representative_title: "VP / FINANCE",
      representative_email: "",
      notes: "",
      create_datetime: "2021-12-23T17:08:09.690853Z",
      modify_datetime: "2021-12-23T17:08:09.690853Z"
    },
    {
      id: 7,
      broker_org_id: "S1039",
      broker_type: 2,
      company_name: "APPLIED INFORMATION GROUP",
      address1: "100 MARKET STREET",
      address2: "",
      city: "KENILWORTH",
      state: "NJ",
      postal_code: "07033-1722",
      federal_tax_id: "0",
      naics_code: "541611",
      phone: "908-241-7007",
      representative_name: "MITCHELL RUBIN",
      representative_title: "PRESIDENT",
      representative_email: "WWW.APPLIEDINFOGROUP.COM",
      notes: "DON LEAPLEY",
      create_datetime: "2021-12-23T17:08:09.690853Z",
      modify_datetime: "2021-12-23T17:08:09.690853Z"
    },
    {
      id: 8,
      broker_org_id: "S1041",
      broker_type: 2,
      company_name: "DBS",
      address1: "430 EISENHOWER LANE N",
      address2: "",
      city: "LOMBARD",
      state: "IL",
      postal_code: "60148",
      federal_tax_id: "36-3944612",
      naics_code: "518210",
      phone: "630-495-5478",
      representative_name: "ROBERT ROTMAN",
      representative_title: "PROJECT LEADER",
      representative_email: "",
      notes: "",
      create_datetime: "2021-12-23T17:08:09.690853Z",
      modify_datetime: "2021-12-23T17:08:09.690853Z"
    },
    {
      id: 9,
      broker_org_id: "S1045",
      broker_type: 2,
      company_name: "THE DATABASE",
      address1: "1710 HIGHWAY 35 SOUTH",
      address2: "",
      city: "OAKHURST",
      state: "NJ",
      postal_code: "07755-2996",
      federal_tax_id: "222969343",
      naics_code: "737401",
      phone: "732-531-4600",
      representative_name: "ROBERT MORAN",
      representative_title: "PRODUCTION MANAGER",
      representative_email: "",
      notes: "",
      create_datetime: "2021-12-23T17:08:09.690853Z",
      modify_datetime: "2021-12-23T17:08:09.690853Z"
    },
    {
      id: 10,
      broker_org_id: "S1047",
      broker_type: 2,
      company_name: "GELIA WELLS & MOHR",
      address1: "11342 MAIN ST",
      address2: "",
      city: "CLARENCE",
      state: "NY",
      postal_code: "14031-1791",
      federal_tax_id: "16-0844960",
      naics_code: "",
      phone: "716-759-0930 X3011",
      representative_name: "AMY WILSON",
      representative_title: "AE",
      representative_email: "",
      notes: "",
      create_datetime: "2021-12-23T17:08:09.690853Z",
      modify_datetime: "2021-12-23T17:08:09.690853Z"
    }
]

